import { Ref } from "react";
import { TextInput as MantineTextInput, TextInputProps as MantineTextInputProps } from "@mantine/core";
import styles from "./styles.module.css";

export interface TextInputProps extends MantineTextInputProps {
  variant?: "filled";
  editable?: boolean;
  ref?: Ref<HTMLInputElement>;
}

function TextInput({ variant, ref, ...props }: TextInputProps) {
  return (
    <MantineTextInput
      classNames={{
        root: styles.root,
        input: variant === "filled" ? styles.inputFilled : "",
      }}
      ref={ref}
      radius={1}
      {...props}
    />
  );
}

export default TextInput;
